<script lang="ts">
	import type { CopyBlock } from '$models/Block/CopyBlock';
	import { sanitizeHtml } from '$lib/utils';

	let { block }: { block: CopyBlock } = $props();

	let backgroundColor = $derived(
		block.variant === 'custom'
			? (block.variantBackgroundColor ?? undefined)
			: block.variant
				? `var(--variant-${block.variant}-color)`
				: undefined
	);
</script>

<div
	class="copy-container"
	class:copy-container--background={block.variant !== 'light'}
	class:copy-container--variant-dark={block.variant === 'dark'}
	class:copy-container--variant-custom={block.variant === 'custom'}
	style:background-color={backgroundColor}
>
	<div class="copy rich-text">
		{@html sanitizeHtml(block.content)}
	</div>
</div>

<style lang="postcss">
	.copy-container--background {
		margin-inline: calc(-1 * var(--spacing-4));
		padding: var(--spacing-8) var(--spacing-4);

		@media (--md) {
			margin-inline: 0;
			border-radius: 16px;
			overflow: hidden;
			padding: var(--spacing-6);
		}

		@media (--lg) {
			padding: var(--spacing-8);
		}

		@media (--xl) {
			padding: var(--spacing-10);
		}
	}

	.copy.rich-text {
		:global(a) {
			color: #005e8e;
			text-decoration: underline;
			transition: color var(--transition);

			&:hover,
			&:focus {
				color: #7bc9ec;
			}
		}

		:global(ul),
		:global(ol),
		:global(li::marker) {
			color: var(--color-brown);
		}

		:global(a:has(strong)),
		:global(strong a) {
			font-family: var(--font-secondary);
			text-transform: uppercase;
		}
	}

	.copy-container--variant-dark,
	.copy-container--variant-custom {
		color: var(--color-white);

		.copy.rich-text {
			:global(a) {
				color: #7bc9ec;

				&:hover,
				&:focus {
					color: var(--color-white);
				}
			}
			:global(ul),
			:global(ol),
			:global(li::marker) {
				color: var(--color-white);
			}
		}
	}
</style>
